module.exports = __webpack_public_path__ + "img/标题.0792048c.svg";